/**
 * Availability guards for optional API fields that must be hidden when absent.
 *
 * Backends omit optional fields (bedrooms, bathrooms, area, price, handover) or
 * send 0 / empty string when a value is unknown, and mapping layers often
 * default them to 0 / ''. All of those mean "not available" for display.
 */

export function hasNumericValue(
    value: number | null | undefined,
): value is number {
    return typeof value === 'number' && Number.isFinite(value) && value > 0;
}

export function hasTextValue(
    value: string | null | undefined,
): value is string {
    return typeof value === 'string' && value.trim().length > 0;
}
